import { DropzoneStatus } from '@/modules/common/components/organisms/file/dropzone';

export enum ImportFileState {
  IDLE = 'IDLE',
  UPLOADING = 'UPLOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export function mapToDropzoneStatus(state: ImportFileState): DropzoneStatus {
  switch (state) {
    case ImportFileState.IDLE:
      return DropzoneStatus.IDLE;
    case ImportFileState.UPLOADING:
      return DropzoneStatus.UPLOADING;
    case ImportFileState.SUCCESS:
      return DropzoneStatus.SUCCESS;
    case ImportFileState.ERROR:
      return DropzoneStatus.ERROR;
  }
}
